exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.center-cropped[data-v-317d11e8] {\n  width: 300px;\n  height: 150px;\n  background-position: center center;\n  background-repeat: no-repeat;\n}\n", ""]);

// exports
